import { useCallback, useEffect, useState } from 'react';
import { EventEmitter } from 'eventemitter3';

// Dismissed callout groups, per browser. Shared by useCallouts and by
// placements that decide by themselves when to show.
export const CACHE_KEY = 'dismissed_callouts';
export const globalStateEmitter = new EventEmitter();

export const onDismissGroup = (group) => {
  if (window.localStorage) {
    const dismissed = (window.localStorage.getItem(CACHE_KEY) || '').split(',');
    if (!dismissed.includes(group)) {
      window.localStorage.setItem(CACHE_KEY, dismissed.filter(Boolean).concat(group).join(','));
    }
  }
  globalStateEmitter.emit('bump');
};

const isGroupDismissed = (group) => (window.localStorage?.getItem(CACHE_KEY) || '').split(',').includes(group);

/**
 * Dismissal of one callout group for a placement that decides by itself when
 * to show, such as a promo that depends on data. Stored with every other
 * callout dismissal, so it is per browser.
 */
export const useCalloutGroupDismissal = (group) => {
  const [, setVersion] = useState(0);
  useEffect(() => {
    const onUpdate = () => setVersion((prevVersion) => prevVersion + 1);
    globalStateEmitter.on('bump', onUpdate);
    return () => globalStateEmitter.off('bump', onUpdate);
  }, []);
  const dismiss = useCallback(() => onDismissGroup(group), [group]);
  return { dismissed: isGroupDismissed(group), dismiss };
};
